import { CATEGORIES_ARABIC } from "../constants/categories";

// Example: ["kitchen", "", "kitchen"] -> ["kitchen"].
export const getOrderCategories = (order = {}) => {
  if (Array.isArray(order.categories)) {
    return [...new Set(order.categories.filter(Boolean))];
  }

  return [];
};

export const getCategoryLabel = (category) => CATEGORIES_ARABIC[category] || category;

// Example: ["kitchen", "office"] -> "مطبخ، مكتب".
export const getOrderCategoriesTitle = (order = {}) =>
  getOrderCategories(order).map(getCategoryLabel).join("، ");

// Example: one category -> "مطبخ"; multiple categories -> "أكثر من صنف (2)".
export const getOrderCategoriesTableLabel = (order = {}) => {
  const categories = getOrderCategories(order);

  if (categories.length === 0) return "غير محدد";
  if (categories.length === 1) return getCategoryLabel(categories[0]);

  return `أكثر من صنف (${categories.length})`;
};
